import { render, staticRenderFns } from "./NodeImage.vue?vue&type=template&id=b398054c"
import script from "./NodeImage.vue?vue&type=script&lang=js"
export * from "./NodeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports